import { BankOperationStatusChipField } from 'pages/Finance/RequestsBankOps/components/BankOperationStatusChipField/BankOperationStatusChipField';
import { RecordContextProvider } from 'react-admin';
import { Chip } from 'shared/mui/Chips';
import { Stack } from 'shared/mui/Stack/Stack';
import { EmbeddedFunctionField, FunctionField } from 'shared/react-admin/Fields';
import { BankOperation, BankOperationStatus } from 'types/embedded/bankOperation';

export const RequestsBankOpsShowChipFields: React.FC = () => {
  return (
    <Stack direction="row" gap={1} sx={{ marginBottom: '24px' }}>
      <FunctionField
        render={(record: BankOperation) => <Chip label={`ID: ${record?.originId}`} size="small" />}
      />
      <FunctionField
        render={(record: BankOperation) =>
          record?.referral ? (
            <Chip
              label={`Реферал: ${record.referral.refId}: ${record.referral.name}`}
              size="small"
            />
          ) : null
        }
      />
      <FunctionField
        render={(record: BankOperation) =>
          record?.merchant ? <Chip label={`Мерчант: ${record.merchant.name}`} size="small" /> : null
        }
      />
      <EmbeddedFunctionField
        render={(value: BankOperationStatus) => (
          <RecordContextProvider value={value}>
            <BankOperationStatusChipField source="description" />
          </RecordContextProvider>
        )}
        sourceField="status"
      />
    </Stack>
  );
};
